export const PROJECT_NAME = "pn";

export const getProjectNameFromQueryParam = (): string | undefined =>
    new URLSearchParams(window.location.search).get(PROJECT_NAME) ?? undefined;
